// extracted by mini-css-extract-plugin
export default {"iconBadge":"IconBadge_iconBadge__Wf8dz"};